import React from 'react';
import { Divider } from 'antd';

function SidebarHome() {
  return (
    <div className="wrapper-sidehome">
      <div className="gioi-thieu">
        <img alt="loader" className="icon-trang-chu" src="/office.svg" />
        <p className="title" style={{ textTransform: 'uppercase' }}>CSDL chuyên ngành <br />công thương</p>
        <p className="content">
          Sở Công Thương là cơ quan chuyên môn thuộc Ủy ban nhân dân cấp tỉnh; thực hiện chức
          năng tham mưu, giúp Ủy ban nhân dân cấp tỉnh quản lý nhà nước về công thương...
        </p>
      </div>
      <Divider />
      <ul className="dia-chi">
        <li>
          <span><i className="fas fa-map-marker-alt bg-icon" /> Số 07 Trần Hưng Đạo, TP.Tam Kỳ, tỉnh Quảng Nam</span>
        </li>
        <li>
          <span><i className="fas fa-phone-volume bg-icon" /> (0235).810605</span>
        </li>
        <li>
          <span><i className="fas fa-globe bg-icon" /> socongthuongqnam@gmail.com</span>
        </li>
      </ul>
    </div>
  );
}

export default SidebarHome;
